import { Injectable, Inject, inject, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PermalinkService } from '../services/permalink.service';

import { TT_LIB_CONFIG } from '../tt-lib.config.token';
import { AppConfig } from '../interfaces/app-config'
import { first } from 'rxjs/operators';

import { Capacitor } from '@capacitor/core';
// import { Device, GetLanguageCodeResult } from '@capacitor/device';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  availableLanguages: readonly string[];
  languages!: {[key: string]: string};
  selectedLang = signal<string | null>(null);
  selectedIndex = signal<number | null>(null);

  private ttLibConfig = inject<AppConfig>(TT_LIB_CONFIG);

  //by default not used, only for android/ios
  private nativeDeviceLanguage: string = null;

  constructor(
    public translateService: TranslateService,
    public permalinkService: PermalinkService,
  ) {
    //langs in config
    this.languages = this.ttLibConfig.langs;
    // this.getNativeDeviceLanguage();
  }

  public init() {
    this.translateService.addLangs(Object.keys(this.languages));
    const language = this.determineLanguage();
    this.setLanguage(language);
    // Sets the fallback language
    this.translateService.setFallbackLang('en');
    // this.translateService.setFallbackLang(this.languages[0]);
  }

  public getLangs() {
    return this.translateService.getLangs();
  }

  private determineLanguage(): string {
    this.availableLanguages = this.translateService.getLangs();

    //permalink
    if (this.availableLanguages.includes(this.permalinkService.getLangParam())) {
      return this.permalinkService.getLangParam();
    }

    //native device language (only ios/android)
    if (this.nativeDeviceLanguage && this.availableLanguages.includes(this.nativeDeviceLanguage)) {
      return this.nativeDeviceLanguage;
    }

    //localstorage
    if (this.availableLanguages.includes(localStorage.getItem('language'))) {
      return localStorage.getItem('language')
    }

    //browser
    if (this.availableLanguages.includes(this.translateService.getBrowserLang())) {
      return this.translateService.getBrowserLang()
    }
    //first in list
    else {
      return this.availableLanguages[0]
    }
  }

  public setLanguage(lang: string) {

    this.translateService.use(lang).subscribe(() => {
      this.selectedLang.set(this.translateService.getCurrentLang());


      if (lang !== this.translateService.getCurrentLang()) {
        //alert('Bug !!!');
         //this.translateService..getCurrentLang() = lang; // obviously, the first time, the property "currentLang" is not changed
        this.translateService.use(lang).subscribe(() => { });
      }
      localStorage.setItem("language", lang);
      //closing time for panel
      setTimeout(() => {
        this.availableLanguages = this.sortLanguages(lang);
      }, 150);
      // ! this method causes troubles with other routes (filters in geobe), keep causing trouble but maybe not necessary anymore?      
      // this.permalinkService.updateLanguage(lang);
      if (window['NgiCookieAlertLayer']) {
        window['NgiCookieAlertLayer'].initCookieAlertLayer(lang);
      }
    });
  }

  sortLanguages(lang) {
    this.selectedIndex.set(this.availableLanguages.map(
      function (lang) {
        return lang;
      }
    ).indexOf(lang));
    let array = this.availableLanguages;
    let sortedArray = [];
    array.forEach((e, i) => {
      if (i === this.selectedIndex())
        sortedArray.unshift(e);
      else
        sortedArray.push(e);
    })
    return sortedArray;
  }

  // private async getNativeDeviceLanguage() {
  //   if (Capacitor.isNativePlatform()) {
  //     Device.getLanguageCode().then((result: GetLanguageCodeResult) => {
  //       this.nativeDeviceLanguage = result && result.value ? result.value : null;

  //       console.log("native lang " + this.nativeDeviceLanguage)
  //       console.log("params " + this.permalinkService.getLangParam())

  //       //if selectedLang was already set in init method while nativeDeviceLanguage  was still null, then update the language again here (unless query has lang param)
  //       if (this.nativeDeviceLanguage
  //         && this.selectedLang()
  //         && this.selectedLang() !== this.nativeDeviceLanguage
  //         && this.availableLanguages
  //         && this.availableLanguages.includes(this.nativeDeviceLanguage)
  //         && !this.permalinkService.getLangParam()) {
  //         this.setLanguage(this.nativeDeviceLanguage);
  //       }
  //     })
  //   }
  // }

  // private sortArray(i) {
    // let temp = this.availableLanguages;
    // let lang = temp[i];
    // temp.splice(i, 1);
    // temp.splice(0, 0, lang);
    // this.availableLanguages = temp;
    // let lang = this.availableLanguages[i];
    // this.availableLanguages.splice(i, 1);
    // this.availableLanguages.splice(0, 0, lang);
  // }

}
